import React, { useMemo } from "react";
import { injectIntl } from "react-intl";
import styled from "styled-components";
import Container from "../layout/Container";
import Row from "../layout/Row";
import Col from "../layout/Col";
import Main from "../layout/Main";
import BoxContainer from "../layout/BoxContainer";
import SectionTitle from "../SectionTitle";
import WorkRow from "../WorkRow";
import SectionSubtitle from "../SectionSubtitle";
import SquareBox from "../SquareBox";
import ContactBox from "../ContactBox";

const HomeStyle = styled(Main)`
  font-family: ${props => props.theme.ffMontserrat};
`;

const contacts = [
  {
    title: 'Email',
    url: 'mailto:arthurmbandeira@gmail.com',
    icon: ['fas', 'envelope']
  },
  {
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/in/arthurmbandeira',
    icon: ['fab', 'linkedin']
  },
  {
    title: 'GitHub',
    url: 'https://github.com/arthurmbandeira',
    icon: ['fab', 'github-alt']
  }
];

const Home = ({ intl, switchTheme }) => {
  const about = intl.formatMessage({ id: 'about' }).split(/(?:\r\n|\r|\n)/g);
  const { messages } = intl;
  return useMemo(() => (
    <HomeStyle>
      <Container small>
        <Row>
          <Col>
            <SquareBox height="200px" heightMd="245px">
              <h2>{intl.formatMessage({ id: 'hello' })}</h2>
              {about.map((line, key) => <p key={key}>{line}</p>)}
            </SquareBox>
          </Col>
        </Row>
        <SectionTitle title={intl.formatMessage({ id: 'experiences' })} />

        <SectionSubtitle title={intl.formatMessage({ id: messages.work.name })} />

        {
          Object.values(messages.work.contents).map(
            (work) => <WorkRow key={work.company} title={work.role}
              company={work.company}
              companyUrl={work.url}
              start={work.start}
              end={work.end}
              description={work.description}
              switchTheme={switchTheme} />
          )
        }

        <SectionSubtitle title={intl.formatMessage({ id: messages.internship.name })} />

        {
          Object.values(messages.internship.contents).map(
            (internship) => <WorkRow key={internship.company} title={internship.role}
              company={internship.company}
              companyUrl={internship.url}
              start={internship.start}
              end={internship.end}
              description={internship.description}
              switchTheme={switchTheme} />
          )
        }

        <SectionTitle title={intl.formatMessage({ id: messages.contact.title })} />

        <BoxContainer>
          {contacts.map((item, key) => <ContactBox key={key} title={item.title} url={item.url} icon={item.icon} />)}
        </BoxContainer>
      </Container>
    </HomeStyle>), [messages]);
}

export default injectIntl(Home);